import React from 'react';

import { BrowserRouter, Route, Switch } from 'react-router-dom';

import NotFound from './NotFound';
import configs from './configs';
import { cleanLoadTexture } from './utils/textureHelper';
// import World from './containers/world';
import { Layout } from 'components/Layout';
import LienKetVungPage from 'pages/LienKetVung';
import TienIchPage from 'pages/TienIch';
import MatBangTangPage from 'pages/MatBangTang';
import CanHoMauPage from 'pages/CanHoMau';
import { WorldFC } from 'components/World';
import TongQuanPage from 'pages/TongQuan';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import { ROUTE_MAP } from 'consts/url';
import SoDoTongThePage from 'pages/SoDoTongThe';

window.defaultTexture = null;
cleanLoadTexture(configs.baseUrl + '/assets/images/white-square.png').then(
  (texture) => {
    window.defaultTexture = texture;
  }
);

function AppRoutes() {
  return (
    <BrowserRouter basename={configs.baseUrl}>
      <Layout>
        {(configs.singleTour && (
          <Switch>
            <Route
              exact
              path="/not-found"
              render={(props) => <NotFound {...props} />}
            />
            <Route
              path="/:sceneId/:hotspotId"
              render={(props) => <WorldFC {...props} />}
            />
            <Route
              path="/:sceneId"
              render={(props) => <WorldFC {...props} />}
            />
            <Route path="/" render={(props) => <WorldFC {...props} />} />
            <Route path="*" render={(props) => <NotFound {...props} />} />
          </Switch>
        )) || (
          <Switch>
            <Route
              exact
              path="/not-found"
              render={(props) => <NotFound {...props} />}
            />
            <Route
              path={`/${ROUTE_MAP.neighborhood.id}/:slug*`}
              render={(props) => <LienKetVungPage {...props} />}
            />
            <Route
              path={`/${ROUTE_MAP.masterplan.id}/:slug*`}
              render={(props) => <SoDoTongThePage {...props} />}
            />
            <Route
              path={`/${ROUTE_MAP['floor-plan'].id}/:slug*`}
              render={(props) => <MatBangTangPage {...props} />}
            />
            <Route
              path={`/${ROUTE_MAP.amenities.id}/:slug*`}
              render={(props) => <TienIchPage {...props} />}
            />
            <Route
              path={`/${ROUTE_MAP.interior.id}/:slug*`}
              render={(props) => <CanHoMauPage {...props} />}
            />
            <Route
              path={`/${ROUTE_MAP.overview.id}/:slug*`}
              render={(props) => <TongQuanPage {...props} />}
            />
            {/* <Route
              path="/can-ho-mau"
              render={(props) => <CanHoMauPage {...props} />}
            /> */}

            {/* <Route
              path="/:groupId/:sceneId/:hotspotId"
              render={(props) => {
                console.log('World props with hotspotId', props);
                return <WorldFC {...props} />;
              }}
            />
            <Route
              path="/:groupId/:sceneId"
              render={(props) => {
                console.log('World props with sceneId', props);
                return <WorldFC {...props} />;
              }}
            />
            <Route
              path="/:groupId"
              render={(props) => <WorldFC {...props} />}
            />
            // <Route path="" render={(props) => <WorldFC {...props} />} /> */}
            <Route
              path=""
              render={(props) => <Redirect to={`/${ROUTE_MAP.overview.id}`} />}
            />
            <Route
              path="/"
              render={() => <Redirect to={`/${ROUTE_MAP.overview.id}`} />}
            />
            <Route path="*" render={(props) => <NotFound {...props} />} />
          </Switch>
        )}
      </Layout>
    </BrowserRouter>
  );
}

export default AppRoutes;
